import { useParams } from "react-router-dom";
import { lazy, Suspense } from 'react';

const RecordList = lazy( () => import("./recordlist") );

export default function RecordListWrapper() {
	let params = useParams();
	return (
		<Suspense fallback={<p>Code bundle not loaded yet...</p>}>
			<RecordList seasonId={params.seasonId} />
		</Suspense>
	);
}